import styled from 'styled-components';

const Note = styled.p`
  font-size: 1rem;
  background-color: ${({ theme }) => theme.colors.attention_bg};
  padding: 6px 8px;
  border-radius: 6px;
  margin-bottom: 0;

  span {
    font-weight: bold;
    cursor: pointer;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
`;

function UnsavedChangesNote({ onDiscard, onSubmit }: { onDiscard: () => void; onSubmit: () => void }) {
  return (
    <Note>
      <i className="pi pi-exclamation-triangle" style={{ marginRight: '4px' }} /> You have to{' '}
      <span onClick={onDiscard}>discard</span> or <span onClick={onSubmit}>save</span> your changes to enable report
      filtering.
    </Note>
  );
}

export default UnsavedChangesNote;
